<template>
    <b-container fluid>
        <div>
            <b-row>
                <b-col cols="12" class="py-2">
                    <label for="reporter">Cargo</label>
                    <app-form-select-input
                        :options="positions"
                        @change="positionSelect"
                        v-model="position"
                    >
                    </app-form-select-input>
                </b-col>
            </b-row>
            <b-row v-if="subordinates.length > 0">
                <b-col cols="6">
                    <h4>Empleados</h4>
                </b-col>
                <b-col cols="6">
                    <h4>Jefes del cargo</h4>
                </b-col>
            </b-row>
            <b-row v-if="flagSubordinates">
                <b-col cols="12">
                    <b-alert show
                        >No hay empleados que reporten a este cargo</b-alert
                    >
                </b-col>
            </b-row>
            <hr />
            <b-row v-for="(subordinate, index) in subordinates" :key="index">
                <b-col cols="6">
                    <label>- {{ subordinate.name }}</label>
                </b-col>
                <b-col cols="6">
                    <app-form-select-input
                        :options="leaders"
                        @change="
                            leaderId =>
                                assignUser(leaderId, subordinate.id, index)
                        "
                    >
                    </app-form-select-input>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
export default {
    props: {
        evaluationId: {
            type: Number,
        },
    },
    data: () => ({
        positions: [],
        subordinates: [],
        leaders: [],
        usersAssigned: [],
        flagSubordinates: false,
        positionLeaderId: '',
        position: '',
    }),
    validations: {},
    methods: {
        async save() {
            if(this.subordinates.length > 0){
                for (let i = 0; i < this.usersAssigned.length; i++) {
                    if (this.usersAssigned[i].leaderId === '') {
                        return toastr.info(
                            'Por favor asigne cada empleado a un jefe'
                        )
                    }
                }
                const relations = this.usersAssigned
                const evaluationId = this.evaluationId
                const { data } = await repo.post('evaluation-users', {
                    relations,
                    evaluationId,
                    positionLeaderId: this.positionLeaderId,
                })
                if (data.status) {
                    this.subordinates = []
                    this.usersAssigned = []
                    this.$emit('saved', data)
                    this.loadPositions()
                } else {
                    toastr.error(data.msg)
                }
            }else{
                toastr.info('Seleccione un cargo para poder filtrar')
            }
        },
        /**
         * metodo change del combo de jefe que reemplaza en la posicion del
         * arreglo indicada la nueva asignación
         */
        assignUser(leaderId, subordinateId, index) {
            if (leaderId) {
                const itemPos = this.usersAssigned[index]
                if (itemPos) {
                    this.usersAssigned.splice(index, 1, {
                        leaderId: leaderId,
                        subordinateId: subordinateId,
                    })
                } else {
                    this.usersAssigned.push({
                        leaderId: leaderId,
                        subordinateId: subordinateId,
                    })
                }
            } else {
                this.usersAssigned.splice(index, 1, {
                    leaderId: '',
                    subordinateId: '',
                })
            }
        },
        async positionSelect(id) {
            this.positionLeaderId = id
            this.subordinates = []
            this.usersAssigned = []
            if (id) {
                const { data } = await repo.get(`positions/${id}/subordinates`)
                this.subordinates = data

                this.loadLeaders(id)

                if (this.subordinates.length === 0) {
                    this.flagSubordinates = true
                }
            }

            if (this.subordinates.length > 0) {
                this.flagSubordinates = false
            }
            //llenamos el arreglo donde se van a asignar a los usuarios y jefes
            //con objetos vacios para que asi al hacer el change la posicion exista
            for (let i = 0; i < this.subordinates.length; i++) {
                this.usersAssigned.push({
                    leaderId: '',
                    subordinateId: '',
                })
            }
        },
        async loadPositions() {
            const { data } = await repo.get('positions/all')
            this.positions = data
        },
        async loadLeaders(id) {
            const { data } = await repo.get(`positions/${id}/leaders`)
            this.leaders = data

            if (data.length === 0) {
                toastr.warning('No hay jefes a cargo')
            }
        },
        reset() {
            this.position = ''
            this.flagSubordinates = false
            //this.loadPositions()
        },
    },
    mounted() {
        this.loadPositions()
    },
}
</script>
